import { Avatar } from "@circleco/compass/components/Avatar";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { classNames } from "@/react/helpers/twMergeWithCN";

export const MentionItem = ({ member, isSelected, handleClick }: any) => (
  <button
    type="button"
    data-testid="mention-item"
    className={classNames(
      "hover:bg-hover flex w-full cursor-pointer items-center px-3 py-2 rounded-md text-primary",
      { "bg-active": isSelected },
    )}
    onClick={handleClick}
  >
    <div className="mr-2">
      {member.type === "group_mention" ? (
        <Icon name="group" size="sm" className="mx-1" />
      ) : (
        <Avatar size="sm" name={member.name} src={member.avatar_url} />
      )}
    </div>

    <Typography variant="body-sm">{member.name}</Typography>
  </button>
);
